
import React, { useContext } from 'react';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';

export const CustomAccordionToggle = ({ className, children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );

    const handleOnClick = (e) => {
        e.stopPropagation();
        decoratedOnClick();
    }

    const isCurrentEventKey = currentEventKey === eventKey;

    if (children)
        return <div className="accordion-header">
            <div
                className={className}
                onClick={(e) => handleOnClick(e)}>
                <i className={` fa toggle-arrow ${isCurrentEventKey ? "fa-caret-down" : "fa-caret-right"}`} aria-hidden="true" />
                <span className="title">{children}</span>
            </div>
        </div>;
    else
        return <i className={`pl-0 pr-2 m-0 fa toggle-arrow ${isCurrentEventKey ? "fa-caret-down" : "fa-caret-right"}`}
            aria-hidden="true"
            onClick={(e) => handleOnClick(e)}
        />;
};